import tripDatabase from "../../generated/trip-database.json";
import articleDatabase from "../../generated/article-database.json";
import NextLink from "next-translate-routes/link";
import {useLocale} from "../../hooks/use-locale";
import {ExternalLink as ExternalLinkIcon} from "../../icons/external-link";
import {Link} from "../link"
import {Link as LinkMUI, LinkProps as LinkMUIProps} from "@mui/material";
import {urlToFileUrl} from "next-translate-routes";

interface AProps {
    href?: string | undefined;
    children?: any;
}

export function A({href, children}: AProps) {

    const locale = useLocale()

    const matches = href?.match(/^\/(trips|articles|articulos)\/([^\/]*)/)

    if (matches) {
        // matches[1] = "trips"
        // matches[2] = "smiling-seahorse"

        if (matches[1] === "trips") {
            const tripId = matches[2]
            const tripData = tripDatabase[tripId as keyof typeof tripDatabase];
            const slugs = tripData?.slugs[locale === "fr" ? "fr" : "en"]

            if (slugs) {
                return <NextLink href={{
                    pathname: "/diving/[countrySlug]/[tripSlug]",
                    query: {countrySlug: slugs.countrySlug, tripSlug: slugs.tripSlug}

                }}
                >{children}</NextLink>
            }

        } else if (matches[1] === "articles") {
            const articleData = articleDatabase[matches[2] as keyof typeof articleDatabase];
            const slugs = articleData?.slugs[locale === "fr" ? "fr" : "en"]

            if (slugs) {
                return <NextLink href={{
                    pathname: "/articles/[articleSlug]",
                    query: {articleSlug: slugs.articleSlug}
                }}

                >{children}</NextLink>
            }
        }
    }

    // didn't match a trip id, so maybe it's a country
    const matchesCountry = href?.match(/^\/([^\/]*)\/(plongee|diving|buceo)\/([^\/]*)\/?$/)

    if (matchesCountry) {
        // matchesCountry[1] = "en"
        // matchesCountry[2] = "diving"
        // matchesCountry[3] = "maldives"
        const target = urlToFileUrl(`/${matchesCountry[2]}/${matchesCountry[3]}`, matchesCountry[1])
        if (target) {
            return <Link href={target}>{children}</Link>
        }
    }

    if (href?.startsWith("http") && !href?.includes("seacrush.com")) {
        // external webpage, open in new window
        return <LinkMUI href={href} target={"_blank"}>{children}<ExternalLinkIcon
            fontSize='small'
            sx={{
                color: "text.secondary",
                cursor: "pointer"
            }}
        /></LinkMUI>
    } else {
        // return <NextLink href={href || "#"}>{children}</NextLink>
        return <LinkMUI href={href}>{children}</LinkMUI>

    }


}
